

const dev = {
  	//API_ENDPOINT_URL: 'http://192.168.192.124:3002/cinemaaurora_back/',
	//API_ENDPOINT_URL: 'http://localhost:3002/cinemaaurora_back/',
	//API_ENDPOINT_URL: 'https://test.esselab.it/badger/',
	API_ENDPOINT_URL: 'https://www.cinema-aurora.it/api/public/',
};

const prod = {
	API_ENDPOINT_URL: 'https://www.cinema-aurora.it/api/public/',
};

const test = {
	API_ENDPOINT_URL: 'http://localhost:3002/cinemaaurora_back/',
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
export const basename = ''//'/new'